import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  FlexDirection,
  JustifyContent,
  Link,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

import configRoutes from 'config/routes'
import { checkoutConstants } from 'routes/Checkout/checkoutConstants'

export const TermsAndConditions = () => (
  <Box
    display="flex"
    flexDirection={FlexDirection.Column}
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
  >
    <Space size={[4, 6]} direction="vertical" />
    <Text size={1}>{checkoutConstants.terms}</Text>
    <Text>
      <Link
        href={configRoutes.client.termsAndConditions}
        color={Color.Secondary_400}
        target="_blank"
      >
        {checkoutConstants.termsLinkText}
      </Link>
    </Text>
  </Box>
)
